import { motion } from 'framer-motion'
import { Trophy, Github, Twitter, Mail, Heart } from 'lucide-react'

const Footer = () => {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-fpl-light-gray border-t border-white/20 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand Section */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="md:col-span-2"
          >
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-8 h-8 bg-gradient-to-br from-fpl-green to-fpl-blue rounded-lg flex items-center justify-center">
                <Trophy className="w-5 h-5 text-white" />
              </div>
              <span className="text-xl font-bold gradient-text">FPL Predictor</span>
            </div>
            <p className="text-fpl-white/70 mb-4 max-w-md">
              AI-powered predictions for Fantasy Premier League success. 
              Make data-driven decisions and dominate your mini-leagues.
            </p>
            <div className="flex space-x-4">
              <motion.a
                href="#"
                whileHover={{ scale: 1.1, y: -2 }}
                className="w-10 h-10 bg-fpl-gray rounded-lg flex items-center justify-center hover:bg-fpl-green transition-colors duration-200"
              >
                <Github className="w-5 h-5 text-white" />
              </motion.a>
              <motion.a
                href="#"
                whileHover={{ scale: 1.1, y: -2 }}
                className="w-10 h-10 bg-fpl-gray rounded-lg flex items-center justify-center hover:bg-fpl-green transition-colors duration-200"
              >
                <Twitter className="w-5 h-5 text-white" />
              </motion.a>
              <motion.a
                href="#"
                whileHover={{ scale: 1.1, y: -2 }}
                className="w-10 h-10 bg-fpl-gray rounded-lg flex items-center justify-center hover:bg-fpl-green transition-colors duration-200"
              >
                <Mail className="w-5 h-5 text-white" />
              </motion.a>
            </div>
          </motion.div>

          {/* Quick Links */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.1 }}
          >
            <h3 className="text-lg font-semibold text-fpl-white mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <a href="#predictions" className="text-fpl-white/70 hover:text-fpl-green transition-colors duration-200">
                  Player Predictions
                </a>
              </li>
              <li>
                <a href="#team-analysis" className="text-fpl-white/70 hover:text-fpl-green transition-colors duration-200">
                  Team Analysis
                </a>
              </li>
              <li>
                <a href="#stats" className="text-fpl-white/70 hover:text-fpl-green transition-colors duration-200">
                  Statistics
                </a>
              </li>
              <li>
                <a href="#leaderboard" className="text-fpl-white/70 hover:text-fpl-green transition-colors duration-200">
                  Leaderboard
                </a>
              </li>
            </ul>
          </motion.div>

          {/* Data Sources */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <h3 className="text-lg font-semibold text-fpl-white mb-4">Data Sources</h3>
            <ul className="space-y-2 text-sm text-fpl-white/70">
              <li>Official FPL API</li>
              <li>Understat Analytics</li>
              <li>API-Football</li>
              <li>The Odds API</li>
            </ul>
          </motion.div>
        </div>

        {/* Bottom Bar */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.3 }}
          className="border-t border-white/20 mt-8 pt-8 text-center"
        >
          <p className="text-fpl-white/60 text-sm">
            © {currentYear} FPL Predictor. Made with{' '}
            <Heart className="inline w-4 h-4 text-fpl-red" />{' '}
            for Fantasy Premier League managers.
          </p>
          <p className="text-fpl-white/40 text-xs mt-2">
            This is not affiliated with the official Fantasy Premier League game.
          </p>
        </motion.div>
      </div>
    </footer>
  )
}

export default Footer
